// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { canUserSeePrices } from "@store/Framework/Store/Data/Accounts/AccountsSelectors";

export default () => {
    return useAppSelector(state => canUserSeePrices(state));
};
